import { FC, useEffect } from 'react';
import '../styles/LoadingAnim.scss';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import userImage from '../../../assets/images/defaultAvatar.png';
import { useAppSelector } from '../../../hooks/store.hooks';
import { addBreadcrumb } from '../../../components/Breadcrumbs/reducer/breadcrumbSlice';
import store from '../../../store/store';

const DetailedPageButtonLink: FC<{ orderId: any; cell: any }> = ({ orderId, cell }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const breadcrumbHandle = async (orderId: any, cell: any) => {
      const data: any = [
        {
          label: 'Orders',
          link: `/orders`,
        },
        {
          label: cell?.value?.name ? cell?.value?.name : cell?.value?.username,
          link: `/orders/${orderId}`,
        },
      ];
      // const data: any = {};
      store.dispatch(addBreadcrumb(data));
      navigate(`/orders/${orderId}`);
  }

  console.log('cellcell', cell)

  return (
    <Link to={`/orders/${orderId}`} onClick={() => breadcrumbHandle(orderId, cell)} className="hover:no-underline cursor-pointer">
      <div className="w-full md:py-2 gap-2 flex items-start max-xl:block max-sm:flex max-sm:justify-start text-start">
        <div className="text-xs max-sm:top-3 max-sm:left-24">
          <p className="text-base text-end md:text-start text-black max-sm:text-sm max-sm:mb-1 underline hover:text-primary1">{cell?.value}</p>
        </div>
      </div>
      {/* {cell.render('Cell')} */}
    </Link>
  );
};

export default DetailedPageButtonLink;
